import { QuestionnaireRespondent } from '@/base/domains';

export const questionnaireRespondent: QuestionnaireRespondent = {
  questionnaireId: 'qid',
  userId: 'uid',
  selectedIndex: 0,
};
